import { Grid, IconButton, Tooltip } from '@mui/material'
import React from 'react'
import { useLang } from '~/hooks/useLang'
import RateReviewOutlinedIcon from '@mui/icons-material/RateReviewOutlined'
import ConfirmDialog from '../ConfirmDialog'
import { useHookstate } from '@hookstate/core'
import { markClerkOccurrence } from '~/features/Clerk/services'
import useDispatchState from '~/features/Dispatch/stores/DispatchState'
import notify from '~/utils/notify'

interface AddClerkProps {
  readonly canClerk?: boolean | null
}

export default function AddClerk({ canClerk }: AddClerkProps) {
  const { translate } = useLang()
  const openDialog = useHookstate(false)
  const { dispatch } = useDispatchState()
  const { occurrence } = dispatch()
  const loading = useHookstate(false)
  const isDisabled = canClerk ? canClerk : false

  const handleDialogCloseFunction = () => {
    loading.set(true)
    markClerkOccurrence({ occurrenceId: occurrence.id.get() })
      .then((response) => {
        if (response.status === 200) {
          notify({
            message: `${translate('Marked successfully')}`,
            type: 'success',
          })
        } else {
          notify({
            message:
              response?.data?.message || translate('Error marking occurrence'),
            type: 'error',
          })
        }
      })
      .catch((err) => {
        notify({
          message: err?.message || translate('Error marking occurrence'),
          type: 'error',
        })
      })
      .finally(() => {
        occurrence.toClerk.set(true)

        handleDialogClose()
      })
  }

  const handleDialogOpen = () => {
    openDialog.set(true)
  }

  const handleDialogClose = () => {
    openDialog.set(false)
    loading.set(false)
  }

  return (
    <Grid item>
      <Tooltip
        title={isDisabled ? translate('Already sent for clerk') : translate('Mark for clerk')}
        componentsProps={{
          tooltip: { sx: { fontSize: '14px', padding: '6px 10px' } },
        }}
      >
        <span style={{ display: 'inline-block' }}>
          <IconButton onClick={() => handleDialogOpen()} disabled={isDisabled}>
            <RateReviewOutlinedIcon />
          </IconButton>
        </span>
      </Tooltip>
      <ConfirmDialog
        handleAgree={handleDialogCloseFunction}
        handleClose={handleDialogClose}
        open={openDialog}
        title={translate('Confirmation')}
        content={translate('Confirm marking of the occurrence for the writer?')}
        loading={loading}
        AgreeLabel={translate('Send')}
      />
    </Grid>
  )
}
